import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(panel => ({
        value: panel.id,
        label: panel.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({commit}, params) {
      try {
        const {data} = await axios.get('v1/intelbras/profiles', {params});

        if (!data) {
          return []
        }

        commit('setData', data.data);
        return data;

      } catch (error) {
        console.error('Error fetching items:', error);
        return [];
      }
    },
    async add(_, params) {
      const { data } = await axios.post('v1/intelbras/profiles', params)

      return data
    },
    async show(_, id) {
      const { data } = await axios.get(`v1/intelbras/profiles/${id}`)

      return data
    },
    async edit(_, {id, params}) {
      const { data } = await axios.put(`v1/intelbras/profiles/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/intelbras/profiles/${id}`)

      return data
    },
    clear({commit}) {
      commit('setData', [])
    }
  },
}
